import Vue from 'vue'
import errors from '@/store/errors'
import { METHODS } from '@/const'

const vue = Vue.prototype
const actions = {
	getClientsManualToolsStatisticsData: async function ({ state, commit, getters, rootState }, input) {
		commit('setClientsManualToolsStatisticsData', [])
		try {
			const result = await rootState.request({
				type: METHODS.GET,
				apiName: 'hqsw',
				url: 'api/v1/clients/limits/manual-tools',
				auth: true,
				query: input?.query
			})

			if (result.has_data && result.data) {
				commit('setClientsManualToolsStatisticsData', result.data)
				return result.data
			}
		} catch (e) {
			vue.$notify({ type: 'error', title: errors.GET_DATA })
			return false
		}
	}
}

export default actions
